/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    cov: {
        id: 'quoteandbind.PLEEveLiaLinedirectives.templates.Information.Coverages',
        defaultMessage: 'Coverages'
    },
    form:{
        id: 'quoteandbind.PLEEveLiaLinedirectives.templates.Information.Endorsements',
        defaultMessage: 'Endorsements'
    },
    totalInsValue: {
        id: 'quoteandbind.PLEEveLiaLinedirectives.templates.Information.Total Insured Value',
        defaultMessage: 'Total Insured Value : '
    }

});